// extracted by mini-css-extract-plugin
export default {"card":"V6-z"};